import { VectorCustomization } from '@yandex/ymaps3-types';

export const style: VectorCustomization = [
  {
    tags: 'country',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ad9d85'
      },
      {
        zoom: 0,
        opacity: 0.8
      },
      {
        zoom: 1,
        opacity: 0.8
      },
      {
        zoom: 2,
        opacity: 0.8
      },
      {
        zoom: 3,
        opacity: 0.8
      },
      {
        zoom: 4,
        opacity: 0.8
      },
      {
        zoom: 5,
        opacity: 1
      },
      {
        zoom: 6,
        opacity: 1
      },
      {
        zoom: 7,
        opacity: 1
      },
      {
        zoom: 8,
        opacity: 1
      },
      {
        zoom: 9,
        opacity: 1
      },
      {
        zoom: 10,
        opacity: 1
      },
      {
        zoom: 11,
        opacity: 1
      },
      {
        zoom: 12,
        opacity: 1
      },
      {
        zoom: 13,
        opacity: 1
      },
      {
        zoom: 14,
        opacity: 1
      },
      {
        zoom: 15,
        opacity: 1
      },
      {
        zoom: 16,
        opacity: 1
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: 'country',
    elements: 'geometry.outline',
    stylers: [
      {
        color: '#e0d0b8'
      },
      {
        zoom: 0,
        opacity: 0.15
      },
      {
        zoom: 1,
        opacity: 0.15
      },
      {
        zoom: 2,
        opacity: 0.15
      },
      {
        zoom: 3,
        opacity: 0.15
      },
      {
        zoom: 4,
        opacity: 0.15
      },
      {
        zoom: 5,
        opacity: 0.15
      },
      {
        zoom: 6,
        opacity: 0.25
      },
      {
        zoom: 7,
        opacity: 0.5
      },
      {
        zoom: 8,
        opacity: 0.47
      },
      {
        zoom: 9,
        opacity: 0.44
      },
      {
        zoom: 10,
        opacity: 0.41
      },
      {
        zoom: 11,
        opacity: 0.38
      },
      {
        zoom: 12,
        opacity: 0.35
      },
      {
        zoom: 13,
        opacity: 0.33
      },
      {
        zoom: 14,
        opacity: 0.3
      },
      {
        zoom: 15,
        opacity: 0.28
      },
      {
        zoom: 16,
        opacity: 0.25
      },
      {
        zoom: 17,
        opacity: 0.25
      },
      {
        zoom: 18,
        opacity: 0.25
      },
      {
        zoom: 19,
        opacity: 0.25
      },
      {
        zoom: 20,
        opacity: 0.25
      },
      {
        zoom: 21,
        opacity: 0.25
      }
    ]
  },
  {
    tags: 'region',
    elements: 'geometry.fill',
    stylers: [
      {
        zoom: 0,
        color: '#c2b6a3',
        opacity: 0.5
      },
      {
        zoom: 1,
        color: '#c2b6a3',
        opacity: 0.5
      },
      {
        zoom: 2,
        color: '#c2b6a3',
        opacity: 0.5
      },
      {
        zoom: 3,
        color: '#c2b6a3',
        opacity: 0.5
      },
      {
        zoom: 4,
        color: '#c2b6a3',
        opacity: 0.5
      },
      {
        zoom: 5,
        color: '#c2b6a3',
        opacity: 0.5
      },
      {
        zoom: 6,
        color: '#c2b6a3',
        opacity: 1
      },
      {
        zoom: 7,
        color: '#c2b6a3',
        opacity: 1
      },
      {
        zoom: 8,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 9,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 10,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 11,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 12,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 13,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 14,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 17,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 18,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 19,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 20,
        color: '#ad9d85',
        opacity: 1
      },
      {
        zoom: 21,
        color: '#ad9d85',
        opacity: 1
      }
    ]
  },
  {
    tags: 'region',
    elements: 'geometry.outline',
    stylers: [
      {
        color: '#e0d0b8'
      },
      {
        zoom: 0,
        opacity: 0.15
      },
      {
        zoom: 1,
        opacity: 0.15
      },
      {
        zoom: 2,
        opacity: 0.15
      },
      {
        zoom: 3,
        opacity: 0.15
      },
      {
        zoom: 4,
        opacity: 0.15
      },
      {
        zoom: 5,
        opacity: 0.15
      },
      {
        zoom: 6,
        opacity: 0.25
      },
      {
        zoom: 7,
        opacity: 0.5
      },
      {
        zoom: 8,
        opacity: 0.47
      },
      {
        zoom: 9,
        opacity: 0.44
      },
      {
        zoom: 10,
        opacity: 0.41
      },
      {
        zoom: 11,
        opacity: 0.38
      },
      {
        zoom: 12,
        opacity: 0.35
      },
      {
        zoom: 13,
        opacity: 0.33
      },
      {
        zoom: 14,
        opacity: 0.3
      },
      {
        zoom: 15,
        opacity: 0.28
      },
      {
        zoom: 16,
        opacity: 0.25
      },
      {
        zoom: 17,
        opacity: 0.25
      },
      {
        zoom: 18,
        opacity: 0.25
      },
      {
        zoom: 19,
        opacity: 0.25
      },
      {
        zoom: 20,
        opacity: 0.25
      },
      {
        zoom: 21,
        opacity: 0.25
      }
    ]
  },
  {
    tags: {
      any: 'admin',
      none: ['country', 'region', 'locality', 'district', 'address']
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ad9d85'
      },
      {
        zoom: 0,
        opacity: 0.5
      },
      {
        zoom: 1,
        opacity: 0.5
      },
      {
        zoom: 2,
        opacity: 0.5
      },
      {
        zoom: 3,
        opacity: 0.5
      },
      {
        zoom: 4,
        opacity: 0.5
      },
      {
        zoom: 5,
        opacity: 0.5
      },
      {
        zoom: 6,
        opacity: 1
      },
      {
        zoom: 7,
        opacity: 1
      },
      {
        zoom: 8,
        opacity: 1
      },
      {
        zoom: 9,
        opacity: 1
      },
      {
        zoom: 10,
        opacity: 1
      },
      {
        zoom: 11,
        opacity: 1
      },
      {
        zoom: 12,
        opacity: 1
      },
      {
        zoom: 13,
        opacity: 1
      },
      {
        zoom: 14,
        opacity: 1
      },
      {
        zoom: 15,
        opacity: 1
      },
      {
        zoom: 16,
        opacity: 1
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: {
      any: 'admin',
      none: ['country', 'region', 'locality', 'district', 'address']
    },
    elements: 'geometry.outline',
    stylers: [
      {
        color: '#e0d0b8'
      },
      {
        zoom: 0,
        opacity: 0.15
      },
      {
        zoom: 1,
        opacity: 0.15
      },
      {
        zoom: 2,
        opacity: 0.15
      },
      {
        zoom: 3,
        opacity: 0.15
      },
      {
        zoom: 4,
        opacity: 0.15
      },
      {
        zoom: 5,
        opacity: 0.15
      },
      {
        zoom: 6,
        opacity: 0.25
      },
      {
        zoom: 7,
        opacity: 0.5
      },
      {
        zoom: 8,
        opacity: 0.47
      },
      {
        zoom: 9,
        opacity: 0.44
      },
      {
        zoom: 10,
        opacity: 0.41
      },
      {
        zoom: 11,
        opacity: 0.38
      },
      {
        zoom: 12,
        opacity: 0.35
      },
      {
        zoom: 13,
        opacity: 0.33
      },
      {
        zoom: 14,
        opacity: 0.3
      },
      {
        zoom: 15,
        opacity: 0.28
      },
      {
        zoom: 16,
        opacity: 0.25
      },
      {
        zoom: 17,
        opacity: 0.25
      },
      {
        zoom: 18,
        opacity: 0.25
      },
      {
        zoom: 19,
        opacity: 0.25
      },
      {
        zoom: 20,
        opacity: 0.25
      },
      {
        zoom: 21,
        opacity: 0.25
      }
    ]
  },
  {
    tags: {
      any: 'landcover',
      none: 'vegetation'
    },
    stylers: [
      {
        hue: '#ddcbb1'
      }
    ]
  },
  {
    tags: 'vegetation',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#cdb38e',
        opacity: 0.1
      },
      {
        zoom: 1,
        color: '#cdb38e',
        opacity: 0.1
      },
      {
        zoom: 2,
        color: '#cdb38e',
        opacity: 0.1
      },
      {
        zoom: 3,
        color: '#cdb38e',
        opacity: 0.1
      },
      {
        zoom: 4,
        color: '#cdb38e',
        opacity: 0.1
      },
      {
        zoom: 5,
        color: '#cdb38e',
        opacity: 0.1
      },
      {
        zoom: 6,
        color: '#cdb38e',
        opacity: 0.2
      },
      {
        zoom: 7,
        color: '#ddcbb1',
        opacity: 0.3
      },
      {
        zoom: 8,
        color: '#ddcbb1',
        opacity: 0.4
      },
      {
        zoom: 9,
        color: '#ddcbb1',
        opacity: 0.6
      },
      {
        zoom: 10,
        color: '#ddcbb1',
        opacity: 0.8
      },
      {
        zoom: 11,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 12,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 13,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 14,
        color: '#e0cfb8',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 17,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 18,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 19,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 20,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 21,
        color: '#e3d4bf',
        opacity: 1
      }
    ]
  },
  {
    tags: 'park',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 1,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 2,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 3,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 4,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 5,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 6,
        color: '#ddcbb1',
        opacity: 0.2
      },
      {
        zoom: 7,
        color: '#ddcbb1',
        opacity: 0.3
      },
      {
        zoom: 8,
        color: '#ddcbb1',
        opacity: 0.4
      },
      {
        zoom: 9,
        color: '#ddcbb1',
        opacity: 0.6
      },
      {
        zoom: 10,
        color: '#ddcbb1',
        opacity: 0.8
      },
      {
        zoom: 11,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 12,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 13,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 14,
        color: '#e0cfb8',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#e3d4bf',
        opacity: 0.9
      },
      {
        zoom: 17,
        color: '#e3d4bf',
        opacity: 0.8
      },
      {
        zoom: 18,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 19,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 20,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 21,
        color: '#e3d4bf',
        opacity: 0.7
      }
    ]
  },
  {
    tags: 'national_park',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 1,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 2,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 3,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 4,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 5,
        color: '#ddcbb1',
        opacity: 0.1
      },
      {
        zoom: 6,
        color: '#ddcbb1',
        opacity: 0.2
      },
      {
        zoom: 7,
        color: '#ddcbb1',
        opacity: 0.3
      },
      {
        zoom: 8,
        color: '#ddcbb1',
        opacity: 0.4
      },
      {
        zoom: 9,
        color: '#ddcbb1',
        opacity: 0.6
      },
      {
        zoom: 10,
        color: '#ddcbb1',
        opacity: 0.8
      },
      {
        zoom: 11,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 12,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 13,
        color: '#ddcbb1',
        opacity: 1
      },
      {
        zoom: 14,
        color: '#e0cfb8',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#e3d4bf',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 17,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 18,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 19,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 20,
        color: '#e3d4bf',
        opacity: 0.7
      },
      {
        zoom: 21,
        color: '#e3d4bf',
        opacity: 0.7
      }
    ]
  },
  {
    tags: 'cemetery',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#ddcbb1'
      },
      {
        zoom: 1,
        color: '#ddcbb1'
      },
      {
        zoom: 2,
        color: '#ddcbb1'
      },
      {
        zoom: 3,
        color: '#ddcbb1'
      },
      {
        zoom: 4,
        color: '#ddcbb1'
      },
      {
        zoom: 5,
        color: '#ddcbb1'
      },
      {
        zoom: 6,
        color: '#ddcbb1'
      },
      {
        zoom: 7,
        color: '#ddcbb1'
      },
      {
        zoom: 8,
        color: '#ddcbb1'
      },
      {
        zoom: 9,
        color: '#ddcbb1'
      },
      {
        zoom: 10,
        color: '#ddcbb1'
      },
      {
        zoom: 11,
        color: '#ddcbb1'
      },
      {
        zoom: 12,
        color: '#ddcbb1'
      },
      {
        zoom: 13,
        color: '#ddcbb1'
      },
      {
        zoom: 14,
        color: '#e0cfb8'
      },
      {
        zoom: 15,
        color: '#e3d4bf'
      },
      {
        zoom: 16,
        color: '#e3d4bf'
      },
      {
        zoom: 17,
        color: '#e3d4bf'
      },
      {
        zoom: 18,
        color: '#e3d4bf'
      },
      {
        zoom: 19,
        color: '#e3d4bf'
      },
      {
        zoom: 20,
        color: '#e3d4bf'
      },
      {
        zoom: 21,
        color: '#e3d4bf'
      }
    ]
  },
  {
    tags: 'sports_ground',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 1,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 2,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 3,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 4,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 5,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 6,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 7,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 8,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 9,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 10,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 11,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 12,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 13,
        color: '#d5c09f',
        opacity: 0
      },
      {
        zoom: 14,
        color: '#d8c5a6',
        opacity: 0
      },
      {
        zoom: 15,
        color: '#dbcaad',
        opacity: 0.5
      },
      {
        zoom: 16,
        color: '#dbcbae',
        opacity: 1
      },
      {
        zoom: 17,
        color: '#dccbb0',
        opacity: 1
      },
      {
        zoom: 18,
        color: '#dcccb1',
        opacity: 1
      },
      {
        zoom: 19,
        color: '#ddcdb2',
        opacity: 1
      },
      {
        zoom: 20,
        color: '#ddcdb4',
        opacity: 1
      },
      {
        zoom: 21,
        color: '#deceb5',
        opacity: 1
      }
    ]
  },
  {
    tags: 'terrain',
    elements: 'geometry',
    stylers: [
      {
        hue: '#ece3d4'
      },
      {
        zoom: 0,
        opacity: 0.3
      },
      {
        zoom: 1,
        opacity: 0.3
      },
      {
        zoom: 2,
        opacity: 0.3
      },
      {
        zoom: 3,
        opacity: 0.3
      },
      {
        zoom: 4,
        opacity: 0.3
      },
      {
        zoom: 5,
        opacity: 0.35
      },
      {
        zoom: 6,
        opacity: 0.4
      },
      {
        zoom: 7,
        opacity: 0.6
      },
      {
        zoom: 8,
        opacity: 0.8
      },
      {
        zoom: 9,
        opacity: 0.9
      },
      {
        zoom: 10,
        opacity: 1
      },
      {
        zoom: 11,
        opacity: 1
      },
      {
        zoom: 12,
        opacity: 1
      },
      {
        zoom: 13,
        opacity: 1
      },
      {
        zoom: 14,
        opacity: 1
      },
      {
        zoom: 15,
        opacity: 1
      },
      {
        zoom: 16,
        opacity: 1
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: 'geographic_line',
    elements: 'geometry',
    stylers: [
      {
        color: '#aa864b'
      }
    ]
  },
  {
    tags: 'land',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#ede2d4'
      },
      {
        zoom: 1,
        color: '#ede2d4'
      },
      {
        zoom: 2,
        color: '#ede2d4'
      },
      {
        zoom: 3,
        color: '#ede2d4'
      },
      {
        zoom: 4,
        color: '#ede2d4'
      },
      {
        zoom: 5,
        color: '#eee4d7'
      },
      {
        zoom: 6,
        color: '#f0e7db'
      },
      {
        zoom: 7,
        color: '#f1e9de'
      },
      {
        zoom: 8,
        color: '#f3ece2'
      },
      {
        zoom: 9,
        color: '#f3ece2'
      },
      {
        zoom: 10,
        color: '#f3ece2'
      },
      {
        zoom: 11,
        color: '#f3ece2'
      },
      {
        zoom: 12,
        color: '#f3ece2'
      },
      {
        zoom: 13,
        color: '#f3ece2'
      },
      {
        zoom: 14,
        color: '#f4eee6'
      },
      {
        zoom: 15,
        color: '#f6f1ea'
      },
      {
        zoom: 16,
        color: '#f6f1ea'
      },
      {
        zoom: 17,
        color: '#f6f2eb'
      },
      {
        zoom: 18,
        color: '#f6f2eb'
      },
      {
        zoom: 19,
        color: '#f7f2ec'
      },
      {
        zoom: 20,
        color: '#f7f3ec'
      },
      {
        zoom: 21,
        color: '#f7f3ed'
      }
    ]
  },
  {
    tags: 'residential',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 1,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 2,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 3,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 4,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 5,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 6,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 7,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 8,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 9,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 10,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 11,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 12,
        color: '#ece3d4',
        opacity: 0.5
      },
      {
        zoom: 13,
        color: '#ece3d4',
        opacity: 1
      },
      {
        zoom: 14,
        color: '#efe7db',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#f3ece3',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#f3ede4',
        opacity: 1
      },
      {
        zoom: 17,
        color: '#f4eee5',
        opacity: 1
      },
      {
        zoom: 18,
        color: '#f4eee6',
        opacity: 1
      },
      {
        zoom: 19,
        color: '#f5efe8',
        opacity: 1
      },
      {
        zoom: 20,
        color: '#f5f0e9',
        opacity: 1
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        opacity: 1
      }
    ]
  },
  {
    tags: 'locality',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#ece3d4'
      },
      {
        zoom: 1,
        color: '#ece3d4'
      },
      {
        zoom: 2,
        color: '#ece3d4'
      },
      {
        zoom: 3,
        color: '#ece3d4'
      },
      {
        zoom: 4,
        color: '#ece3d4'
      },
      {
        zoom: 5,
        color: '#ece3d4'
      },
      {
        zoom: 6,
        color: '#ece3d4'
      },
      {
        zoom: 7,
        color: '#ece3d4'
      },
      {
        zoom: 8,
        color: '#ece3d4'
      },
      {
        zoom: 9,
        color: '#ece3d4'
      },
      {
        zoom: 10,
        color: '#ece3d4'
      },
      {
        zoom: 11,
        color: '#ece3d4'
      },
      {
        zoom: 12,
        color: '#ece3d4'
      },
      {
        zoom: 13,
        color: '#ece3d4'
      },
      {
        zoom: 14,
        color: '#efe7db'
      },
      {
        zoom: 15,
        color: '#f3ece3'
      },
      {
        zoom: 16,
        color: '#f3ede4'
      },
      {
        zoom: 17,
        color: '#f4eee5'
      },
      {
        zoom: 18,
        color: '#f4eee6'
      },
      {
        zoom: 19,
        color: '#f5efe8'
      },
      {
        zoom: 20,
        color: '#f5f0e9'
      },
      {
        zoom: 21,
        color: '#f6f1ea'
      }
    ]
  },
  {
    tags: {
      any: 'structure',
      none: ['building', 'fence']
    },
    elements: 'geometry',
    stylers: [
      {
        opacity: 0.9
      },
      {
        zoom: 0,
        color: '#ece3d4'
      },
      {
        zoom: 1,
        color: '#ece3d4'
      },
      {
        zoom: 2,
        color: '#ece3d4'
      },
      {
        zoom: 3,
        color: '#ece3d4'
      },
      {
        zoom: 4,
        color: '#ece3d4'
      },
      {
        zoom: 5,
        color: '#ece3d4'
      },
      {
        zoom: 6,
        color: '#ece3d4'
      },
      {
        zoom: 7,
        color: '#ece3d4'
      },
      {
        zoom: 8,
        color: '#ece3d4'
      },
      {
        zoom: 9,
        color: '#ece3d4'
      },
      {
        zoom: 10,
        color: '#ece3d4'
      },
      {
        zoom: 11,
        color: '#ece3d4'
      },
      {
        zoom: 12,
        color: '#ece3d4'
      },
      {
        zoom: 13,
        color: '#ece3d4'
      },
      {
        zoom: 14,
        color: '#efe7db'
      },
      {
        zoom: 15,
        color: '#f3ece3'
      },
      {
        zoom: 16,
        color: '#f3ede4'
      },
      {
        zoom: 17,
        color: '#f4eee5'
      },
      {
        zoom: 18,
        color: '#f4eee6'
      },
      {
        zoom: 19,
        color: '#f5efe8'
      },
      {
        zoom: 20,
        color: '#f5f0e9'
      },
      {
        zoom: 21,
        color: '#f6f1ea'
      }
    ]
  },
  {
    tags: 'building',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#e5d7c2'
      },
      {
        zoom: 0,
        opacity: 0.7
      },
      {
        zoom: 1,
        opacity: 0.7
      },
      {
        zoom: 2,
        opacity: 0.7
      },
      {
        zoom: 3,
        opacity: 0.7
      },
      {
        zoom: 4,
        opacity: 0.7
      },
      {
        zoom: 5,
        opacity: 0.7
      },
      {
        zoom: 6,
        opacity: 0.7
      },
      {
        zoom: 7,
        opacity: 0.7
      },
      {
        zoom: 8,
        opacity: 0.7
      },
      {
        zoom: 9,
        opacity: 0.7
      },
      {
        zoom: 10,
        opacity: 0.7
      },
      {
        zoom: 11,
        opacity: 0.7
      },
      {
        zoom: 12,
        opacity: 0.7
      },
      {
        zoom: 13,
        opacity: 0.7
      },
      {
        zoom: 14,
        opacity: 0.7
      },
      {
        zoom: 15,
        opacity: 0.7
      },
      {
        zoom: 16,
        opacity: 0.9
      },
      {
        zoom: 17,
        opacity: 0.6
      },
      {
        zoom: 18,
        opacity: 0.6
      },
      {
        zoom: 19,
        opacity: 0.6
      },
      {
        zoom: 20,
        opacity: 0.6
      },
      {
        zoom: 21,
        opacity: 0.6
      }
    ]
  },
  {
    tags: 'building',
    elements: 'geometry.outline',
    stylers: [
      {
        color: '#d9c3a6'
      },
      {
        zoom: 0,
        opacity: 0.5
      },
      {
        zoom: 1,
        opacity: 0.5
      },
      {
        zoom: 2,
        opacity: 0.5
      },
      {
        zoom: 3,
        opacity: 0.5
      },
      {
        zoom: 4,
        opacity: 0.5
      },
      {
        zoom: 5,
        opacity: 0.5
      },
      {
        zoom: 6,
        opacity: 0.5
      },
      {
        zoom: 7,
        opacity: 0.5
      },
      {
        zoom: 8,
        opacity: 0.5
      },
      {
        zoom: 9,
        opacity: 0.5
      },
      {
        zoom: 10,
        opacity: 0.5
      },
      {
        zoom: 11,
        opacity: 0.5
      },
      {
        zoom: 12,
        opacity: 0.5
      },
      {
        zoom: 13,
        opacity: 0.5
      },
      {
        zoom: 14,
        opacity: 0.5
      },
      {
        zoom: 15,
        opacity: 0.5
      },
      {
        zoom: 16,
        opacity: 0.5
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: {
      any: 'urban_area',
      none: [
        'residential',
        'industrial',
        'cemetery',
        'park',
        'medical',
        'sports_ground',
        'beach',
        'construction_site'
      ]
    },
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 1,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 2,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 3,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 4,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 5,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 6,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 7,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 8,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 9,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 10,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 11,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 12,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 13,
        color: '#e6dac6',
        opacity: 1
      },
      {
        zoom: 14,
        color: '#eae0cf',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#eee6d8',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#f2ebe1',
        opacity: 0.67
      },
      {
        zoom: 17,
        color: '#f6f1ea',
        opacity: 0.33
      },
      {
        zoom: 18,
        color: '#f6f1ea',
        opacity: 0
      },
      {
        zoom: 19,
        color: '#f6f1ea',
        opacity: 0
      },
      {
        zoom: 20,
        color: '#f6f1ea',
        opacity: 0
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        opacity: 0
      }
    ]
  },
  {
    tags: 'poi',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'poi',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'poi',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'outdoor',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'outdoor',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'outdoor',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'park',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'park',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'park',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'cemetery',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'cemetery',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'cemetery',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'beach',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'beach',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'beach',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'medical',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'medical',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'medical',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'shopping',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'shopping',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'shopping',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'commercial_services',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'commercial_services',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'commercial_services',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'food_and_drink',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'food_and_drink',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#6a522f'
      }
    ]
  },
  {
    tags: 'food_and_drink',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'road',
    elements: 'label.icon',
    types: 'point',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        'tertiary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'road',
    elements: 'label.text.fill',
    types: 'point',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    tags: 'entrance',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      },
      {
        hue: '#dac7aa'
      }
    ]
  },
  {
    tags: 'locality',
    elements: 'label.icon',
    stylers: [
      {
        color: '#dac7aa'
      },
      {
        'secondary-color': '#ffffff'
      }
    ]
  },
  {
    tags: 'country',
    elements: 'label.text.fill',
    stylers: [
      {
        opacity: 0.8
      },
      {
        color: '#a07c46'
      }
    ]
  },
  {
    tags: 'country',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'region',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#a07c46'
      },
      {
        opacity: 0.8
      }
    ]
  },
  {
    tags: 'region',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'district',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#a07c46'
      },
      {
        opacity: 0.8
      }
    ]
  },
  {
    tags: 'district',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: {
      any: 'admin',
      none: ['country', 'region', 'locality', 'district', 'address']
    },
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#a07c46'
      }
    ]
  },
  {
    tags: {
      any: 'admin',
      none: ['country', 'region', 'locality', 'district', 'address']
    },
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'locality',
    elements: 'label.text.fill',
    stylers: [
      {
        zoom: 0,
        color: '#6a522f'
      },
      {
        zoom: 1,
        color: '#6a522f'
      },
      {
        zoom: 2,
        color: '#6a522f'
      },
      {
        zoom: 3,
        color: '#6a522f'
      },
      {
        zoom: 4,
        color: '#6a522f'
      },
      {
        zoom: 5,
        color: '#67502e'
      },
      {
        zoom: 6,
        color: '#644e2c'
      },
      {
        zoom: 7,
        color: '#624c2b'
      },
      {
        zoom: 8,
        color: '#5f492a'
      },
      {
        zoom: 9,
        color: '#5c4728'
      },
      {
        zoom: 10,
        color: '#594527'
      },
      {
        zoom: 11,
        color: '#594527'
      },
      {
        zoom: 12,
        color: '#594527'
      },
      {
        zoom: 13,
        color: '#594527'
      },
      {
        zoom: 14,
        color: '#594527'
      },
      {
        zoom: 15,
        color: '#594527'
      },
      {
        zoom: 16,
        color: '#594527'
      },
      {
        zoom: 17,
        color: '#594527'
      },
      {
        zoom: 18,
        color: '#594527'
      },
      {
        zoom: 19,
        color: '#594527'
      },
      {
        zoom: 20,
        color: '#594527'
      },
      {
        zoom: 21,
        color: '#594527'
      }
    ]
  },
  {
    tags: 'locality',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'road',
    elements: 'label.text.fill',
    types: 'polyline',
    stylers: [
      {
        color: '#7c6036'
      }
    ]
  },
  {
    tags: 'road',
    elements: 'label.text.outline',
    types: 'polyline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'road',
    elements: 'geometry.fill.pattern',
    types: 'polyline',
    stylers: [
      {
        scale: 1
      },
      {
        color: '#b9955f'
      }
    ]
  },
  {
    tags: 'road',
    elements: 'label.text.fill',
    types: 'point',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    tags: 'structure',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#8e6f3e'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'structure',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'address',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#8e6f3e'
      },
      {
        zoom: 0,
        opacity: 0.9
      },
      {
        zoom: 1,
        opacity: 0.9
      },
      {
        zoom: 2,
        opacity: 0.9
      },
      {
        zoom: 3,
        opacity: 0.9
      },
      {
        zoom: 4,
        opacity: 0.9
      },
      {
        zoom: 5,
        opacity: 0.9
      },
      {
        zoom: 6,
        opacity: 0.9
      },
      {
        zoom: 7,
        opacity: 0.9
      },
      {
        zoom: 8,
        opacity: 0.9
      },
      {
        zoom: 9,
        opacity: 0.9
      },
      {
        zoom: 10,
        opacity: 0.9
      },
      {
        zoom: 11,
        opacity: 0.9
      },
      {
        zoom: 12,
        opacity: 0.9
      },
      {
        zoom: 13,
        opacity: 0.9
      },
      {
        zoom: 14,
        opacity: 0.9
      },
      {
        zoom: 15,
        opacity: 0.9
      },
      {
        zoom: 16,
        opacity: 0.9
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: 'address',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'landscape',
    elements: 'label.text.fill',
    stylers: [
      {
        zoom: 0,
        color: '#a07c46',
        opacity: 1
      },
      {
        zoom: 1,
        color: '#a07c46',
        opacity: 1
      },
      {
        zoom: 2,
        color: '#a07c46',
        opacity: 1
      },
      {
        zoom: 3,
        color: '#a07c46',
        opacity: 1
      },
      {
        zoom: 4,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 5,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 6,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 7,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 8,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 9,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 10,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 11,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 12,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 13,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 14,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 15,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 16,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 17,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 18,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 19,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 20,
        color: '#8e6f3e',
        opacity: 0.5
      },
      {
        zoom: 21,
        color: '#8e6f3e',
        opacity: 0.5
      }
    ]
  },
  {
    tags: 'landscape',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        opacity: 0.5
      },
      {
        zoom: 1,
        opacity: 0.5
      },
      {
        zoom: 2,
        opacity: 0.5
      },
      {
        zoom: 3,
        opacity: 0.5
      },
      {
        zoom: 4,
        opacity: 0
      },
      {
        zoom: 5,
        opacity: 0
      },
      {
        zoom: 6,
        opacity: 0
      },
      {
        zoom: 7,
        opacity: 0
      },
      {
        zoom: 8,
        opacity: 0
      },
      {
        zoom: 9,
        opacity: 0
      },
      {
        zoom: 10,
        opacity: 0
      },
      {
        zoom: 11,
        opacity: 0
      },
      {
        zoom: 12,
        opacity: 0
      },
      {
        zoom: 13,
        opacity: 0
      },
      {
        zoom: 14,
        opacity: 0
      },
      {
        zoom: 15,
        opacity: 0
      },
      {
        zoom: 16,
        opacity: 0
      },
      {
        zoom: 17,
        opacity: 0
      },
      {
        zoom: 18,
        opacity: 0
      },
      {
        zoom: 19,
        opacity: 0
      },
      {
        zoom: 20,
        opacity: 0
      },
      {
        zoom: 21,
        opacity: 0
      }
    ]
  },
  {
    tags: 'water',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#7c6136'
      },
      {
        opacity: 0.8
      }
    ]
  },
  {
    tags: 'water',
    elements: 'label.text.outline',
    types: 'polyline',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        opacity: 0.2
      }
    ]
  },
  {
    tags: {
      any: 'road_1',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 2.97
      },
      {
        zoom: 7,
        scale: 3.19
      },
      {
        zoom: 8,
        scale: 3.53
      },
      {
        zoom: 9,
        scale: 4
      },
      {
        zoom: 10,
        scale: 3.61
      },
      {
        zoom: 11,
        scale: 3.06
      },
      {
        zoom: 12,
        scale: 2.64
      },
      {
        zoom: 13,
        scale: 2.27
      },
      {
        zoom: 14,
        scale: 2.03
      },
      {
        zoom: 15,
        scale: 1.9
      },
      {
        zoom: 16,
        scale: 1.86
      },
      {
        zoom: 17,
        scale: 1.48
      },
      {
        zoom: 18,
        scale: 1.21
      },
      {
        zoom: 19,
        scale: 1.04
      },
      {
        zoom: 20,
        scale: 0.94
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_1'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#00000000',
        scale: 3.05
      },
      {
        zoom: 7,
        color: '#00000000',
        scale: 3.05
      },
      {
        zoom: 8,
        color: '#e9dfcd',
        scale: 3.15
      },
      {
        zoom: 9,
        color: '#ece3d4',
        scale: 3.37
      },
      {
        zoom: 10,
        color: '#ece3d4',
        scale: 3.36
      },
      {
        zoom: 11,
        color: '#ece3d4',
        scale: 3.17
      },
      {
        zoom: 12,
        color: '#ece3d4',
        scale: 3
      },
      {
        zoom: 13,
        color: '#ece3d4',
        scale: 2.8
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 2.66
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 2.61
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 2.64
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 2.14
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.79
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.55
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.41
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.35
      }
    ]
  },
  {
    tags: {
      any: 'road_2',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 2.97
      },
      {
        zoom: 7,
        scale: 3.19
      },
      {
        zoom: 8,
        scale: 3.53
      },
      {
        zoom: 9,
        scale: 4
      },
      {
        zoom: 10,
        scale: 3.61
      },
      {
        zoom: 11,
        scale: 3.06
      },
      {
        zoom: 12,
        scale: 2.64
      },
      {
        zoom: 13,
        scale: 2.27
      },
      {
        zoom: 14,
        scale: 2.03
      },
      {
        zoom: 15,
        scale: 1.9
      },
      {
        zoom: 16,
        scale: 1.86
      },
      {
        zoom: 17,
        scale: 1.48
      },
      {
        zoom: 18,
        scale: 1.21
      },
      {
        zoom: 19,
        scale: 1.04
      },
      {
        zoom: 20,
        scale: 0.94
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_2'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#00000000',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#00000000',
        scale: 3.05
      },
      {
        zoom: 7,
        color: '#00000000',
        scale: 3.05
      },
      {
        zoom: 8,
        color: '#e9dfcd',
        scale: 3.15
      },
      {
        zoom: 9,
        color: '#ece3d4',
        scale: 3.37
      },
      {
        zoom: 10,
        color: '#ece3d4',
        scale: 3.36
      },
      {
        zoom: 11,
        color: '#ece3d4',
        scale: 3.17
      },
      {
        zoom: 12,
        color: '#ece3d4',
        scale: 3
      },
      {
        zoom: 13,
        color: '#ece3d4',
        scale: 2.8
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 2.66
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 2.61
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 2.64
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 2.14
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.79
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.55
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.41
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.35
      }
    ]
  },
  {
    tags: {
      any: 'road_3',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 2.51
      },
      {
        zoom: 10,
        scale: 2.62
      },
      {
        zoom: 11,
        scale: 1.68
      },
      {
        zoom: 12,
        scale: 1.67
      },
      {
        zoom: 13,
        scale: 1.38
      },
      {
        zoom: 14,
        scale: 1.19
      },
      {
        zoom: 15,
        scale: 1.08
      },
      {
        zoom: 16,
        scale: 1.04
      },
      {
        zoom: 17,
        scale: 0.91
      },
      {
        zoom: 18,
        scale: 0.84
      },
      {
        zoom: 19,
        scale: 0.82
      },
      {
        zoom: 20,
        scale: 0.84
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_3'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 1.6
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 1.29
      },
      {
        zoom: 9,
        color: '#ece3d4',
        scale: 4.21
      },
      {
        zoom: 10,
        color: '#ece3d4',
        scale: 2.74
      },
      {
        zoom: 11,
        color: '#ece3d4',
        scale: 2.04
      },
      {
        zoom: 12,
        color: '#ece3d4',
        scale: 2.13
      },
      {
        zoom: 13,
        color: '#ece3d4',
        scale: 1.88
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 1.7
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 1.59
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.55
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.37
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.27
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.23
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.26
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.35
      }
    ]
  },
  {
    tags: {
      any: 'road_4',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 1.69
      },
      {
        zoom: 11,
        scale: 1.26
      },
      {
        zoom: 12,
        scale: 1.41
      },
      {
        zoom: 13,
        scale: 1.19
      },
      {
        zoom: 14,
        scale: 1.04
      },
      {
        zoom: 15,
        scale: 0.97
      },
      {
        zoom: 16,
        scale: 1.15
      },
      {
        zoom: 17,
        scale: 0.99
      },
      {
        zoom: 18,
        scale: 0.89
      },
      {
        zoom: 19,
        scale: 0.85
      },
      {
        zoom: 20,
        scale: 0.85
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_4'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 1.12
      },
      {
        zoom: 10,
        color: '#ece3d4',
        scale: 1.9
      },
      {
        zoom: 11,
        color: '#ece3d4',
        scale: 1.62
      },
      {
        zoom: 12,
        color: '#ece3d4',
        scale: 1.83
      },
      {
        zoom: 13,
        color: '#ece3d4',
        scale: 1.64
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 1.51
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 1.44
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.69
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.47
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.34
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.28
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.28
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.34
      }
    ]
  },
  {
    tags: {
      any: 'road_5',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 0
      },
      {
        zoom: 11,
        scale: 0
      },
      {
        zoom: 12,
        scale: 1.25
      },
      {
        zoom: 13,
        scale: 0.95
      },
      {
        zoom: 14,
        scale: 0.81
      },
      {
        zoom: 15,
        scale: 0.95
      },
      {
        zoom: 16,
        scale: 1.1
      },
      {
        zoom: 17,
        scale: 0.93
      },
      {
        zoom: 18,
        scale: 0.85
      },
      {
        zoom: 19,
        scale: 0.82
      },
      {
        zoom: 20,
        scale: 0.84
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_5'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 10,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 11,
        color: '#ffffff',
        scale: 0.62
      },
      {
        zoom: 12,
        color: '#ece3d4',
        scale: 1.61
      },
      {
        zoom: 13,
        color: '#ece3d4',
        scale: 1.36
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 1.22
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 1.41
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.63
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.4
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.27
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.23
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.25
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.34
      }
    ]
  },
  {
    tags: {
      any: 'road_6',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 0
      },
      {
        zoom: 11,
        scale: 0
      },
      {
        zoom: 12,
        scale: 0
      },
      {
        zoom: 13,
        scale: 2.25
      },
      {
        zoom: 14,
        scale: 1.27
      },
      {
        zoom: 15,
        scale: 1.25
      },
      {
        zoom: 16,
        scale: 1.31
      },
      {
        zoom: 17,
        scale: 1.04
      },
      {
        zoom: 18,
        scale: 0.9
      },
      {
        zoom: 19,
        scale: 0.85
      },
      {
        zoom: 20,
        scale: 0.85
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_6'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 10,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 11,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 12,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 13,
        color: '#ece3d4',
        scale: 2.31
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 1.7
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 1.76
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.89
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.55
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.36
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.27
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.27
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.34
      }
    ]
  },
  {
    tags: {
      any: 'road_7',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 0
      },
      {
        zoom: 11,
        scale: 0
      },
      {
        zoom: 12,
        scale: 0
      },
      {
        zoom: 13,
        scale: 0
      },
      {
        zoom: 14,
        scale: 0.9
      },
      {
        zoom: 15,
        scale: 0.78
      },
      {
        zoom: 16,
        scale: 0.88
      },
      {
        zoom: 17,
        scale: 0.8
      },
      {
        zoom: 18,
        scale: 0.78
      },
      {
        zoom: 19,
        scale: 0.79
      },
      {
        zoom: 20,
        scale: 0.83
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_7'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 10,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 11,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 12,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 13,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 1.31
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 1.19
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.31
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.21
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.17
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.18
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.23
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.33
      }
    ]
  },
  {
    tags: {
      any: 'road_minor',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 0
      },
      {
        zoom: 11,
        scale: 0
      },
      {
        zoom: 12,
        scale: 0
      },
      {
        zoom: 13,
        scale: 0
      },
      {
        zoom: 14,
        scale: 0
      },
      {
        zoom: 15,
        scale: 0
      },
      {
        zoom: 16,
        scale: 0.9
      },
      {
        zoom: 17,
        scale: 0.9
      },
      {
        zoom: 18,
        scale: 0.9
      },
      {
        zoom: 19,
        scale: 0.9
      },
      {
        zoom: 20,
        scale: 0.9
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_minor'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 10,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 11,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 12,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 13,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 0.4
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 0.4
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.4
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.27
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.27
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.29
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.31
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.32
      }
    ]
  },
  {
    tags: {
      any: 'road_unclassified',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 0
      },
      {
        zoom: 11,
        scale: 0
      },
      {
        zoom: 12,
        scale: 0
      },
      {
        zoom: 13,
        scale: 0
      },
      {
        zoom: 14,
        scale: 0
      },
      {
        zoom: 15,
        scale: 0
      },
      {
        zoom: 16,
        scale: 0.9
      },
      {
        zoom: 17,
        scale: 0.9
      },
      {
        zoom: 18,
        scale: 0.9
      },
      {
        zoom: 19,
        scale: 0.9
      },
      {
        zoom: 20,
        scale: 0.9
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: {
      any: 'road_unclassified'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 10,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 11,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 12,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 13,
        color: '#ffffff',
        scale: 0.4
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 0.4
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 0.4
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 1.4
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 1.27
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 1.27
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.29
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.31
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.32
      }
    ]
  },
  {
    tags: {
      all: 'is_tunnel',
      none: 'path'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        zoom: 0,
        color: '#e9dfcd'
      },
      {
        zoom: 1,
        color: '#e9dfcd'
      },
      {
        zoom: 2,
        color: '#e9dfcd'
      },
      {
        zoom: 3,
        color: '#e9dfcd'
      },
      {
        zoom: 4,
        color: '#e9dfcd'
      },
      {
        zoom: 5,
        color: '#e9dfcd'
      },
      {
        zoom: 6,
        color: '#e9dfcd'
      },
      {
        zoom: 7,
        color: '#e9dfcd'
      },
      {
        zoom: 8,
        color: '#e9dfcd'
      },
      {
        zoom: 9,
        color: '#e9dfcd'
      },
      {
        zoom: 10,
        color: '#e9dfcd'
      },
      {
        zoom: 11,
        color: '#e9dfcd'
      },
      {
        zoom: 12,
        color: '#e9dfcd'
      },
      {
        zoom: 13,
        color: '#e9dfcd'
      },
      {
        zoom: 14,
        color: '#ece3d4'
      },
      {
        zoom: 15,
        color: '#efe8dc'
      },
      {
        zoom: 16,
        color: '#f0e9dd'
      },
      {
        zoom: 17,
        color: '#f0e9de'
      },
      {
        zoom: 18,
        color: '#f1eadf'
      },
      {
        zoom: 19,
        color: '#f2ebe1'
      },
      {
        zoom: 20,
        color: '#f2ebe2'
      },
      {
        zoom: 21,
        color: '#f3ece3'
      }
    ]
  },
  {
    tags: {
      all: 'path',
      none: 'is_tunnel'
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#c4a678'
      }
    ]
  },
  {
    tags: {
      all: 'path',
      none: 'is_tunnel'
    },
    elements: 'geometry.outline',
    stylers: [
      {
        opacity: 0.7
      },
      {
        zoom: 0,
        color: '#ece3d4'
      },
      {
        zoom: 1,
        color: '#ece3d4'
      },
      {
        zoom: 2,
        color: '#ece3d4'
      },
      {
        zoom: 3,
        color: '#ece3d4'
      },
      {
        zoom: 4,
        color: '#ece3d4'
      },
      {
        zoom: 5,
        color: '#ece3d4'
      },
      {
        zoom: 6,
        color: '#ece3d4'
      },
      {
        zoom: 7,
        color: '#ece3d4'
      },
      {
        zoom: 8,
        color: '#ece3d4'
      },
      {
        zoom: 9,
        color: '#ece3d4'
      },
      {
        zoom: 10,
        color: '#ece3d4'
      },
      {
        zoom: 11,
        color: '#ece3d4'
      },
      {
        zoom: 12,
        color: '#ece3d4'
      },
      {
        zoom: 13,
        color: '#ece3d4'
      },
      {
        zoom: 14,
        color: '#efe7db'
      },
      {
        zoom: 15,
        color: '#f3ece3'
      },
      {
        zoom: 16,
        color: '#f3ede4'
      },
      {
        zoom: 17,
        color: '#f4eee5'
      },
      {
        zoom: 18,
        color: '#f4eee6'
      },
      {
        zoom: 19,
        color: '#f5efe8'
      },
      {
        zoom: 20,
        color: '#f5f0e9'
      },
      {
        zoom: 21,
        color: '#f6f1ea'
      }
    ]
  },
  {
    tags: 'road_construction',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    tags: 'road_construction',
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#d3bd9c'
      },
      {
        zoom: 1,
        color: '#d3bd9c'
      },
      {
        zoom: 2,
        color: '#d3bd9c'
      },
      {
        zoom: 3,
        color: '#d3bd9c'
      },
      {
        zoom: 4,
        color: '#d3bd9c'
      },
      {
        zoom: 5,
        color: '#d3bd9c'
      },
      {
        zoom: 6,
        color: '#d3bd9c'
      },
      {
        zoom: 7,
        color: '#d3bd9c'
      },
      {
        zoom: 8,
        color: '#d3bd9c'
      },
      {
        zoom: 9,
        color: '#d3bd9c'
      },
      {
        zoom: 10,
        color: '#d3bd9c'
      },
      {
        zoom: 11,
        color: '#d3bd9c'
      },
      {
        zoom: 12,
        color: '#d3bd9c'
      },
      {
        zoom: 13,
        color: '#d3bd9c'
      },
      {
        zoom: 14,
        color: '#c4a678'
      },
      {
        zoom: 15,
        color: '#d3bd9c'
      },
      {
        zoom: 16,
        color: '#d6c1a2'
      },
      {
        zoom: 17,
        color: '#d8c5a8'
      },
      {
        zoom: 18,
        color: '#dbc9ad'
      },
      {
        zoom: 19,
        color: '#decdb3'
      },
      {
        zoom: 20,
        color: '#e0d1b9'
      },
      {
        zoom: 21,
        color: '#e3d5bf'
      }
    ]
  },
  {
    tags: {
      any: 'ferry'
    },
    stylers: [
      {
        color: '#b9975f'
      }
    ]
  },
  {
    tags: 'transit_location',
    elements: 'label.icon',
    stylers: [
      {
        hue: '#dac7aa'
      },
      {
        saturation: -0.61
      }
    ]
  },
  {
    tags: 'transit_location',
    elements: 'label.text.fill',
    stylers: [
      {
        color: '#b89f7a'
      }
    ]
  },
  {
    tags: 'transit_location',
    elements: 'label.text.outline',
    stylers: [
      {
        color: '#ffffff'
      }
    ]
  },
  {
    tags: 'transit_schema',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#b89f7a'
      },
      {
        scale: 0.7
      },
      {
        zoom: 0,
        opacity: 0.6
      },
      {
        zoom: 1,
        opacity: 0.6
      },
      {
        zoom: 2,
        opacity: 0.6
      },
      {
        zoom: 3,
        opacity: 0.6
      },
      {
        zoom: 4,
        opacity: 0.6
      },
      {
        zoom: 5,
        opacity: 0.6
      },
      {
        zoom: 6,
        opacity: 0.6
      },
      {
        zoom: 7,
        opacity: 0.6
      },
      {
        zoom: 8,
        opacity: 0.6
      },
      {
        zoom: 9,
        opacity: 0.6
      },
      {
        zoom: 10,
        opacity: 0.6
      },
      {
        zoom: 11,
        opacity: 0.6
      },
      {
        zoom: 12,
        opacity: 0.6
      },
      {
        zoom: 13,
        opacity: 0.6
      },
      {
        zoom: 14,
        opacity: 0.6
      },
      {
        zoom: 15,
        opacity: 0.5
      },
      {
        zoom: 16,
        opacity: 0.4
      },
      {
        zoom: 17,
        opacity: 0.4
      },
      {
        zoom: 18,
        opacity: 0.4
      },
      {
        zoom: 19,
        opacity: 0.4
      },
      {
        zoom: 20,
        opacity: 0.4
      },
      {
        zoom: 21,
        opacity: 0.4
      }
    ]
  },
  {
    tags: 'transit_schema',
    elements: 'geometry.outline',
    stylers: [
      {
        opacity: 0
      }
    ]
  },
  {
    tags: 'transit_line',
    elements: 'geometry.fill.pattern',
    stylers: [
      {
        color: '#c2b6a3'
      },
      {
        zoom: 0,
        opacity: 0
      },
      {
        zoom: 1,
        opacity: 0
      },
      {
        zoom: 2,
        opacity: 0
      },
      {
        zoom: 3,
        opacity: 0
      },
      {
        zoom: 4,
        opacity: 0
      },
      {
        zoom: 5,
        opacity: 0
      },
      {
        zoom: 6,
        opacity: 0
      },
      {
        zoom: 7,
        opacity: 0
      },
      {
        zoom: 8,
        opacity: 0
      },
      {
        zoom: 9,
        opacity: 0
      },
      {
        zoom: 10,
        opacity: 0
      },
      {
        zoom: 11,
        opacity: 0
      },
      {
        zoom: 12,
        opacity: 0
      },
      {
        zoom: 13,
        opacity: 1
      },
      {
        zoom: 14,
        opacity: 1
      },
      {
        zoom: 15,
        opacity: 1
      },
      {
        zoom: 16,
        opacity: 1
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: 'transit_line',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#c2b6a3'
      },
      {
        scale: 0.4
      },
      {
        zoom: 0,
        opacity: 0
      },
      {
        zoom: 1,
        opacity: 0
      },
      {
        zoom: 2,
        opacity: 0
      },
      {
        zoom: 3,
        opacity: 0
      },
      {
        zoom: 4,
        opacity: 0
      },
      {
        zoom: 5,
        opacity: 0
      },
      {
        zoom: 6,
        opacity: 0
      },
      {
        zoom: 7,
        opacity: 0
      },
      {
        zoom: 8,
        opacity: 0
      },
      {
        zoom: 9,
        opacity: 0
      },
      {
        zoom: 10,
        opacity: 0
      },
      {
        zoom: 11,
        opacity: 0
      },
      {
        zoom: 12,
        opacity: 0
      },
      {
        zoom: 13,
        opacity: 1
      },
      {
        zoom: 14,
        opacity: 1
      },
      {
        zoom: 15,
        opacity: 1
      },
      {
        zoom: 16,
        opacity: 1
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: 'water',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#c9ae83'
      },
      {
        zoom: 1,
        color: '#c9ae83'
      },
      {
        zoom: 2,
        color: '#c9ae83'
      },
      {
        zoom: 3,
        color: '#c9ae83'
      },
      {
        zoom: 4,
        color: '#c9ae83'
      },
      {
        zoom: 5,
        color: '#c9ae83'
      },
      {
        zoom: 6,
        color: '#c9ae83'
      },
      {
        zoom: 7,
        color: '#c9ae83'
      },
      {
        zoom: 8,
        color: '#cab085'
      },
      {
        zoom: 9,
        color: '#cbb188'
      },
      {
        zoom: 10,
        color: '#ccb38a'
      },
      {
        zoom: 11,
        color: '#ccb48b'
      },
      {
        zoom: 12,
        color: '#cdb48d'
      },
      {
        zoom: 13,
        color: '#cdb58e'
      },
      {
        zoom: 14,
        color: '#ceb690'
      },
      {
        zoom: 15,
        color: '#ceb791'
      },
      {
        zoom: 16,
        color: '#cfb893'
      },
      {
        zoom: 17,
        color: '#d0b995'
      },
      {
        zoom: 18,
        color: '#d1bb97'
      },
      {
        zoom: 19,
        color: '#d1bc98'
      },
      {
        zoom: 20,
        color: '#d2bd9a'
      },
      {
        zoom: 21,
        color: '#d3be9c'
      }
    ]
  },
  {
    tags: 'water',
    elements: 'geometry',
    types: 'polyline',
    stylers: [
      {
        zoom: 0,
        opacity: 0.4
      },
      {
        zoom: 1,
        opacity: 0.4
      },
      {
        zoom: 2,
        opacity: 0.4
      },
      {
        zoom: 3,
        opacity: 0.4
      },
      {
        zoom: 4,
        opacity: 0.6
      },
      {
        zoom: 5,
        opacity: 0.8
      },
      {
        zoom: 6,
        opacity: 1
      },
      {
        zoom: 7,
        opacity: 1
      },
      {
        zoom: 8,
        opacity: 1
      },
      {
        zoom: 9,
        opacity: 1
      },
      {
        zoom: 10,
        opacity: 1
      },
      {
        zoom: 11,
        opacity: 1
      },
      {
        zoom: 12,
        opacity: 1
      },
      {
        zoom: 13,
        opacity: 1
      },
      {
        zoom: 14,
        opacity: 1
      },
      {
        zoom: 15,
        opacity: 1
      },
      {
        zoom: 16,
        opacity: 1
      },
      {
        zoom: 17,
        opacity: 1
      },
      {
        zoom: 18,
        opacity: 1
      },
      {
        zoom: 19,
        opacity: 1
      },
      {
        zoom: 20,
        opacity: 1
      },
      {
        zoom: 21,
        opacity: 1
      }
    ]
  },
  {
    tags: 'bathymetry',
    elements: 'geometry',
    stylers: [
      {
        hue: '#c9ae83'
      }
    ]
  },
  {
    tags: {
      any: ['industrial', 'construction_site']
    },
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#e9decd'
      },
      {
        zoom: 1,
        color: '#e9decd'
      },
      {
        zoom: 2,
        color: '#e9decd'
      },
      {
        zoom: 3,
        color: '#e9decd'
      },
      {
        zoom: 4,
        color: '#e9decd'
      },
      {
        zoom: 5,
        color: '#e9decd'
      },
      {
        zoom: 6,
        color: '#e9decd'
      },
      {
        zoom: 7,
        color: '#e9decd'
      },
      {
        zoom: 8,
        color: '#e9decd'
      },
      {
        zoom: 9,
        color: '#e9decd'
      },
      {
        zoom: 10,
        color: '#e9decd'
      },
      {
        zoom: 11,
        color: '#e9decd'
      },
      {
        zoom: 12,
        color: '#e9decd'
      },
      {
        zoom: 13,
        color: '#e9decd'
      },
      {
        zoom: 14,
        color: '#ece2d4'
      },
      {
        zoom: 15,
        color: '#efe7dc'
      },
      {
        zoom: 16,
        color: '#f0e8dd'
      },
      {
        zoom: 17,
        color: '#f0e9de'
      },
      {
        zoom: 18,
        color: '#f1e9df'
      },
      {
        zoom: 19,
        color: '#f2eae1'
      },
      {
        zoom: 20,
        color: '#f2ebe2'
      },
      {
        zoom: 21,
        color: '#f3ece3'
      }
    ]
  },
  {
    tags: {
      any: 'transit',
      none: [
        'transit_location',
        'transit_line',
        'transit_schema',
        'is_unclassified_transit'
      ]
    },
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#e9decd'
      },
      {
        zoom: 1,
        color: '#e9decd'
      },
      {
        zoom: 2,
        color: '#e9decd'
      },
      {
        zoom: 3,
        color: '#e9decd'
      },
      {
        zoom: 4,
        color: '#e9decd'
      },
      {
        zoom: 5,
        color: '#e9decd'
      },
      {
        zoom: 6,
        color: '#e9decd'
      },
      {
        zoom: 7,
        color: '#e9decd'
      },
      {
        zoom: 8,
        color: '#e9decd'
      },
      {
        zoom: 9,
        color: '#e9decd'
      },
      {
        zoom: 10,
        color: '#e9decd'
      },
      {
        zoom: 11,
        color: '#e9decd'
      },
      {
        zoom: 12,
        color: '#e9decd'
      },
      {
        zoom: 13,
        color: '#e9decd'
      },
      {
        zoom: 14,
        color: '#ece2d4'
      },
      {
        zoom: 15,
        color: '#efe7dc'
      },
      {
        zoom: 16,
        color: '#f0e8dd'
      },
      {
        zoom: 17,
        color: '#f0e9de'
      },
      {
        zoom: 18,
        color: '#f1e9df'
      },
      {
        zoom: 19,
        color: '#f2eae1'
      },
      {
        zoom: 20,
        color: '#f2ebe2'
      },
      {
        zoom: 21,
        color: '#f3ece3'
      }
    ]
  },
  {
    tags: 'fence',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#e3d5bf'
      },
      {
        zoom: 0,
        opacity: 0.75
      },
      {
        zoom: 1,
        opacity: 0.75
      },
      {
        zoom: 2,
        opacity: 0.75
      },
      {
        zoom: 3,
        opacity: 0.75
      },
      {
        zoom: 4,
        opacity: 0.75
      },
      {
        zoom: 5,
        opacity: 0.75
      },
      {
        zoom: 6,
        opacity: 0.75
      },
      {
        zoom: 7,
        opacity: 0.75
      },
      {
        zoom: 8,
        opacity: 0.75
      },
      {
        zoom: 9,
        opacity: 0.75
      },
      {
        zoom: 10,
        opacity: 0.75
      },
      {
        zoom: 11,
        opacity: 0.75
      },
      {
        zoom: 12,
        opacity: 0.75
      },
      {
        zoom: 13,
        opacity: 0.75
      },
      {
        zoom: 14,
        opacity: 0.75
      },
      {
        zoom: 15,
        opacity: 0.75
      },
      {
        zoom: 16,
        opacity: 0.75
      },
      {
        zoom: 17,
        opacity: 0.45
      },
      {
        zoom: 18,
        opacity: 0.45
      },
      {
        zoom: 19,
        opacity: 0.45
      },
      {
        zoom: 20,
        opacity: 0.45
      },
      {
        zoom: 21,
        opacity: 0.45
      }
    ]
  },
  {
    tags: 'medical',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#e9decd'
      },
      {
        zoom: 1,
        color: '#e9decd'
      },
      {
        zoom: 2,
        color: '#e9decd'
      },
      {
        zoom: 3,
        color: '#e9decd'
      },
      {
        zoom: 4,
        color: '#e9decd'
      },
      {
        zoom: 5,
        color: '#e9decd'
      },
      {
        zoom: 6,
        color: '#e9decd'
      },
      {
        zoom: 7,
        color: '#e9decd'
      },
      {
        zoom: 8,
        color: '#e9decd'
      },
      {
        zoom: 9,
        color: '#e9decd'
      },
      {
        zoom: 10,
        color: '#e9decd'
      },
      {
        zoom: 11,
        color: '#e9decd'
      },
      {
        zoom: 12,
        color: '#e9decd'
      },
      {
        zoom: 13,
        color: '#e9decd'
      },
      {
        zoom: 14,
        color: '#ece2d4'
      },
      {
        zoom: 15,
        color: '#efe7dc'
      },
      {
        zoom: 16,
        color: '#f0e8dd'
      },
      {
        zoom: 17,
        color: '#f0e9de'
      },
      {
        zoom: 18,
        color: '#f1e9df'
      },
      {
        zoom: 19,
        color: '#f2eae1'
      },
      {
        zoom: 20,
        color: '#f2ebe2'
      },
      {
        zoom: 21,
        color: '#f3ece3'
      }
    ]
  },
  {
    tags: 'beach',
    elements: 'geometry',
    stylers: [
      {
        zoom: 0,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 1,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 2,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 3,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 4,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 5,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 6,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 7,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 8,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 9,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 10,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 11,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 12,
        color: '#e9decd',
        opacity: 0.3
      },
      {
        zoom: 13,
        color: '#e9decd',
        opacity: 0.65
      },
      {
        zoom: 14,
        color: '#ece2d4',
        opacity: 1
      },
      {
        zoom: 15,
        color: '#efe7dc',
        opacity: 1
      },
      {
        zoom: 16,
        color: '#f0e8dd',
        opacity: 1
      },
      {
        zoom: 17,
        color: '#f0e9de',
        opacity: 1
      },
      {
        zoom: 18,
        color: '#f1e9df',
        opacity: 1
      },
      {
        zoom: 19,
        color: '#f2eae1',
        opacity: 1
      },
      {
        zoom: 20,
        color: '#f2ebe2',
        opacity: 1
      },
      {
        zoom: 21,
        color: '#f3ece3',
        opacity: 1
      }
    ]
  },
  {
    tags: {
      all: ['is_tunnel', 'path']
    },
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#c1a171'
      },
      {
        opacity: 0.3
      }
    ]
  },
  {
    tags: {
      all: ['is_tunnel', 'path']
    },
    elements: 'geometry.outline',
    stylers: [
      {
        opacity: 0
      }
    ]
  },
  {
    tags: 'road_limited',
    elements: 'geometry.fill',
    stylers: [
      {
        color: '#ccb18a'
      },
      {
        zoom: 0,
        scale: 0
      },
      {
        zoom: 1,
        scale: 0
      },
      {
        zoom: 2,
        scale: 0
      },
      {
        zoom: 3,
        scale: 0
      },
      {
        zoom: 4,
        scale: 0
      },
      {
        zoom: 5,
        scale: 0
      },
      {
        zoom: 6,
        scale: 0
      },
      {
        zoom: 7,
        scale: 0
      },
      {
        zoom: 8,
        scale: 0
      },
      {
        zoom: 9,
        scale: 0
      },
      {
        zoom: 10,
        scale: 0
      },
      {
        zoom: 11,
        scale: 0
      },
      {
        zoom: 12,
        scale: 0
      },
      {
        zoom: 13,
        scale: 0.1
      },
      {
        zoom: 14,
        scale: 0.2
      },
      {
        zoom: 15,
        scale: 0.3
      },
      {
        zoom: 16,
        scale: 0.5
      },
      {
        zoom: 17,
        scale: 0.6
      },
      {
        zoom: 18,
        scale: 0.7
      },
      {
        zoom: 19,
        scale: 0.79
      },
      {
        zoom: 20,
        scale: 0.83
      },
      {
        zoom: 21,
        scale: 0.9
      }
    ]
  },
  {
    tags: 'road_limited',
    elements: 'geometry.outline',
    stylers: [
      {
        zoom: 0,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 1,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 2,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 3,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 4,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 5,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 6,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 7,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 8,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 9,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 10,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 11,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 12,
        color: '#ffffff',
        scale: 1.4
      },
      {
        zoom: 13,
        color: '#ffffff',
        scale: 0.1
      },
      {
        zoom: 14,
        color: '#efe8dc',
        scale: 0.2
      },
      {
        zoom: 15,
        color: '#efe8dc',
        scale: 0.3
      },
      {
        zoom: 16,
        color: '#f0eade',
        scale: 0.5
      },
      {
        zoom: 17,
        color: '#f1ebe1',
        scale: 0.6
      },
      {
        zoom: 18,
        color: '#f3ede3',
        scale: 0.7
      },
      {
        zoom: 19,
        color: '#f4efe6',
        scale: 1.18
      },
      {
        zoom: 20,
        color: '#f5f0e8',
        scale: 1.23
      },
      {
        zoom: 21,
        color: '#f6f1ea',
        scale: 1.33
      }
    ]
  },
  {
    tags: {
      any: 'poi',
      none: ['outdoor', 'park', 'cemetery', 'medical']
    },
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: 'road'
    },
    types: 'point',
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: ['food_and_drink', 'shopping', 'commercial_services']
    },
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: ['traffic_light']
    },
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: ['entrance']
    },
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: ['road'],
      none: [
        'road_1',
        'road_2',
        'road_3',
        'road_4',
        'road_5',
        'road_6',
        'road_7'
      ]
    },
    elements: 'label.icon',
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: [
        'address',
        'road_7',
        'road_limited',
        'road_unclassified',
        'road_minor',
        'road_construction',
        'path'
      ]
    },
    elements: 'label',
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: ['transit']
    },
    stylers: {
      visibility: 'off'
    }
  },
  {
    tags: {
      any: 'landcover',
      none: 'vegetation'
    },
    stylers: {
      visibility: 'off'
    }
  }
];
